import { formatDistanceToNowStrict } from 'date-fns';
export const displayDateAge = (date, practiceId = 0) => {
    return formatDistanceToNowStrict(date, { roundingMethod: 'floor' });
};
